export default {
	GET_VALIDATE_EMAIL_RESULT: state => state.validateEmailResult,
    GET_VALIDATE_EMAIL_ERROR: state => state.validateEmailError,
}